<template>
    <div>
        <template v-if="showType == 'input'">
            <el-input
                v-if="limit == 1"
                :placeholder="placeholder"
                :disabled="disabled"
                :size="size"
                :readonly="isReadonly"
                style="line-hight: 40px"
                @blur="changeVal"
                v-model="name"
                class="input-with-select"
                width="60%"
            >
                <el-button slot="append" :disabled="disabled" @click="showSelectDialog"
                           icon="el-icon-search"></el-button>
            </el-input>
            <el-input
                v-if="limit > 1 && !btn"
                type="textarea"
                :placeholder="placeholder"
                :disabled="disabled"
                :size="size"
                :readonly="isReadonly"
                :rows="6"
                @blur="changeVal"
                v-model="name"
                class="input-with-select"
                style="width: 100%;"
            >
            </el-input>
        </template>
        <template v-else-if="showType == 'button'">
            <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="showSelectDialog"
            >{{ placeholder }}
            </el-button>
        </template>
        <button v-if="btn" type="button" @click="showSelectDialog" class="el-button btn el-button--primary"><span>添加试题</span></button>
        <!-- <el-button slot="append" :disabled="disabled" @click="showSelectDialog" icon="el-icon-search"></el-button> -->
        <el-dialog :title="title" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible"
                   width="80%">
            <el-row :gutter="15">
                <el-col :span="limit == 1 ? 24 : 18">
                    <el-form style="padding: 0; margin: 0;" :inline="true" ref="searchForm" class="query-form"
                             @keyup.enter.native="refreshList()" @submit.native.prevent>
                        <template  v-for="(search, index) in searchs">
                            <el-form-item :prop="search.prop" v-if="search.sign != 'hidden'">
                                <el-input size="small" v-model="searchForms[index]" :placeholder="search.label"
                                          clearable></el-input>
                            </el-form-item>
                        </template>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList()" size="small">查询</el-button>
                            <el-button @click="resetSearch()" size="small">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table
                        :data="dataList"
                        v-loading="loading"
                        border
                        size="small"
                        ref="userTable"
                        @selection-change="selectionChangeHandle"
                        @sort-change="sortChangeHandle"
                        style="width: 100%"
                    >
                        <el-table-column v-if="limit != 1" type="selection" header-align="center" align="center"
                                         width="50"></el-table-column>
                        <template v-for="(column, index) in columns">

                            <!-- <el-table-column
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                                v-if="column.sign == 'product'"
                            >
                                <template slot-scope="scope">
                                    <template v-for="(item,key) in scope.row.children">
                                        <img class="i1" v-if="item.img == 'img'" :src="item.prop" alt="" />
                                        <div style="text-align:left" v-else>{{ item.label }}: {{ item.prop }}</div>
                                    </template>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                                :key="index"
                                header-align="center"
                                :prop="column.prop"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                                v-if="column.img == 'img'"
                            >
                                <template slot-scope="scope">
                                    <img class="i1" :src="scope.row[column.prop]" alt="" />
                                </template>
                            </el-table-column>

                            <el-table-column
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                                v-else-if="column.img == 'twolabel'"
                            >
                                <template slot-scope="scope">
                                    {{geteval(scope.row,column.prop)}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                :key="index"
                                :prop="column.prop"
                                header-align="center"
                                align="center"
                                min-width="100px"
                                :label="column.label"
                                v-else
                            >
                                <template slot-scope="scope">
                                    <div v-if="column.children == undefined">{{ scope.row[column.prop] }}</div>
                                    <div v-else>
                                        <div style="text-align:left" v-for="(item,key) in column.children">{{ item.label
                                            }}: {{ scope.row[item.prop] }}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>



                        </template>
                        <el-table-column
                            v-if="limit== 1"
                            fixed="right"
                            align="center"
                            label="操作"
                            width="200">
                            <template slot-scope="scope">
                                <el-button @click="selectionChangeHandleSingle(scope.row)" type="text" size="small">
                                    选择
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageNo"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                    ></el-pagination>
                </el-col>
                <el-col :span="6" v-show="limit != 1">
                    <el-tag :key="tag.id" v-for="tag in dataListAllSelections" closable :disable-transitions="false"
                            @close="del(tag)">{{
                            tag[labelName]
                        }}
                    </el-tag>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">关闭</el-button>
                <el-button type="primary" v-if="limit != 1" @click="doSubmit()">确定</el-button>
            </span>
            <!-- <ConsultRecord :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></ConsultRecord> -->
        </el-dialog>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
import eventBus from '@/api/eventBus';

import { getUserById } from '@/api/user.js';
//import DictTypeListTable from '@/components/system/DictTypeListTable.vue';
export default {
    data() {
        return {
            shopListForm: {
                catalogId: '',
                productName: '', //商品id
                catalogName: '' //类别类型
            },
            pageSizes: 10,
            currentPage: 1,
            totalNum: 0,
            searchForms: [],
            filterText: '',
            dataListAllSelections: [], // 所有选中的数据包含跨页数据
            dataListSelections: [],
            idKey: 'id', // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
            dataList: [],
            dynamicTags: [],
            selectData: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            visible: false,
            name: '',
            types: null,
            relatedFee: '',
            enname: '',
            dataListSelections1: {}
        };
    },
    props: {
        // did: {
        //     type: String
        // },
        resultObj:{
            type: Boolean,
            default: false
        },
        showType: {
            type: String,
            default: 'input'
        },
        limit: {
            type: Number,
            default: 1
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        searchs: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dataListUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        queryEntityUrl: {
            type: String,
            default: () => {
                return null;
            }
        },
        entityBeanName: {
            type: String,
            default: () => {
                return null;
            }
        },
        value: {
            type: String,
            default: () => {
                return '';
            }
        },
        title: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelName: {
            type: String,
            default: () => {
                return '';
            }
        },
        labelValue: {
            type: String,
            default: () => {
                return '';
            }
        },
        size: {
            type: String,
            default: () => {
                return 'default';
            }
        },
        goodsCategoryName: {
            type: String,
            default: () => {
                return '';
            }
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
        ParentComponentName: {
            type: String,
            default: () => {
                return '';
            }
        },
        userName: {
            type: String,
            default: () => {
                return '';
            }
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        btn:{
            type: Boolean,
            default: false
        },
        token: {
            type: String,
            default: localStorage.getItem('token')
        },
    },
    watch: {
        value: {
            handler(newVal) {
                console.log('newVal', newVal);
                this.selectData = [];
                if (newVal) {
                    newVal.split(',').forEach((value) => {
                        if (value) {
                            get(this.queryEntityUrl, { id: value }).then((data) => {
                                console.log(data);
                                // console.log('data[this.entityBeanName][this.labelValue]'+data.mppUser);
                                if (data[this.entityBeanName][this.labelValue] !== '') {
                                    this.selectData.push(data[this.entityBeanName]);
                                }
                            });
                            // getUserById({id: value}).then(())
                        }
                    });
                }
            },
            immediate: true,
            deep: false
        },
        userName: {
            handler(newVal) {
                this.name = '';
                // if (newVal) {
                //     this.name = newVal;
                // }
            }
        },
        selectData: {
            handler(newVal) {
                this.dataListAllSelections = JSON.parse(JSON.stringify(this.selectData));
                this.name = this.dataListAllSelections
                    .map((item) => {
                        return item[this.labelName];
                    })
                    .join(',');
            },
            immediate: false,
            deep: false
        }
    },
    created() {
        eventBus.$on('empty', (data) => {
            console.log(131312131);
            // 不改变原组件的值
            this.name = '';
        });
        console.log('????');
        console.log(this.columns);
    },
    methods: {
        geteval(scope,label){
            return(eval('scope.' + label))
        },

        // 单选
        selectionChangeHandleSingle(val) {
            this.dataListSelections1 = val;
            console.log(val);
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
            this.doSubmit('1');
        },
        init(type) {
            this.visible = true;
            if(this.btn){
                this.types = type;
            }
            this.$nextTick(() => {
                this.resetSearch();
            });
        },
        // 设置选中的方法
        setSelectRow() {
            if (!this.dataListAllSelections || this.dataListAllSelections.length <= 0) {
                this.$refs.userTable.clearSelection();
                return;
            }
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            this.$refs.userTable.clearSelection();
            for (var i = 0; i < this.dataList.length; i++) {
                if (selectAllIds.indexOf(this.dataList[i][idKey]) >= 0) {
                    // 设置选中，记住table组件需要使用ref="table"
                    this.$refs.userTable.toggleRowSelection(this.dataList[i], true);
                }
            }
        },
        // 记忆选择核心方法
        changePageCoreRecordData() {
            // 标识当前行的唯一键的名称
            let idKey = this.idKey;
            let that = this;
            // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
            if (this.dataListAllSelections.length <= 0) {
                this.dataListSelections.forEach((row) => {
                    that.dataListAllSelections.push(row);
                });
                return;
            }
            // 总选择里面的key集合
            let selectAllIds = [];
            this.dataListAllSelections.forEach((row) => {
                selectAllIds.push(row[idKey]);
            });
            let selectIds = [];
            // 获取当前页选中的id
            this.dataListSelections.forEach((row) => {
                selectIds.push(row[idKey]);
                // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
                if (selectAllIds.indexOf(row[idKey]) < 0) {
                    that.dataListAllSelections.push(row);
                }
            });
            let noSelectIds = [];
            // 得到当前页没有选中的id
            this.dataList.forEach((row) => {
                if (selectIds.indexOf(row[idKey]) < 0) {
                    noSelectIds.push(row[idKey]);
                }
            });
            noSelectIds.forEach((id) => {
                if (selectAllIds.indexOf(id) >= 0) {
                    for (let i = 0; i < that.dataListAllSelections.length; i++) {
                        if (that.dataListAllSelections[i][idKey] === id) {
                            // 如果总选择中有未被选中的，那么就删除这条
                            that.dataListAllSelections.splice(i, 1);
                            break;
                        }
                    }
                }
            });
        },
        // 得到选中的所有数据
        getAllSelectionData() {
            // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
            this.changePageCoreRecordData();
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        del(tag) {
            this.dataListAllSelections.splice(this.dataListAllSelections.indexOf(tag), 1);
            this.$nextTick(() => {
                this.setSelectRow();
            });
        },
        // 获取数据列表
        refreshList() {
            this.loading = true;
            let searchForm = {
                id: ''
            };
            console.log(this.searchs)
            this.searchs.forEach((search, index) => {
                if(search.sign == 'hidden'){
                    searchForm[search.prop] = this.types;
                }else{
                    searchForm[search.prop] = this.searchForms[index];
                }
            });
            // console.log(this.did);
            // searchForm.id = this.did;
            // console.log({...searchForm});
            console.log(searchForm, "????");
            get(this.dataListUrl, { ...searchForm, pageNum: this.pageNo, pageSize: this.pageSize }).then((res) => {
                if (res.success) {
                    // console.log(this.did);
                    // console.log(this.shopListForm);
                    // this.shopListForm.catalogId = this.did;
                    // get(`/shop/shopProductCatalogList/findList`, {
                    //     ...this.shopListForm,
                    //     pageNum: this.currentPage,
                    //     pageSize: this.pageSizes
                    // }).then((res) => {
                    //     this.loading = false;
                    //     if (res.success) {
                    //         console.log(res.page.list);
                    // this.totalNums = 0;
                    // this.shopProductClassifyList = res.page.list;
                    // this.totalNums = res.page.total;
                    //     }
                    // });

                    // get(`/shop/shopProductCatalogList/findAll`, { ...this.did }).then((res) => {
                    //     if (res.success) {
                    //         console.log(res.list);
                    //     }
                    // });
                    this.dataList = res.page.list;
                    // console.log(this.dataList);
                    // this.compare();
                    console.log(this.did);
                    this.total = res.page.total;
                    this.loading = false;
                }
            });
        },
        compare() {
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageNo = val;
            this.refreshList();
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
            console.log(val);
            this.$nextTick(() => {
                this.changePageCoreRecordData();
            });
        },
        // 排序
        sortChangeHandle(obj) {
            if (obj.order === 'ascending') {
                this.orderBy = obj.prop + ' asc';
            } else if (obj.order === 'descending') {
                this.orderBy = obj.prop + ' desc';
            } else {
                this.orderBy = '';
            }
            this.refreshList();
        },
        resetSearch() {
            this.$refs.searchForm.resetFields();
            this.searchForms = [];
            this.refreshList();
        },
        doSubmit(val = '') {
            if (val == '1') {
                this.name = this.dataListSelections1[this.labelName];
                value = this.dataListSelections1[this.labelValue];
                if(this.resultObj){
                    this.$emit('getValue', this.dataListSelections1, this.name);
                } else {
                    this.$emit('getValue', value, this.name);
                }
                this.visible = false;
                return;
            }
            if (this.limit < this.dataListAllSelections.length) {
                this.$message.error(`你最多只能选择${this.limit}条数据`);
                return;
            }
            this.visible = false;
            this.name = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelName];
                })
                .join(',');
            let value = this.dataListAllSelections
                .map((item) => {
                    return item[this.labelValue];
                })
                .join(',');
            if (this.limit == 1) {

                if(this.resultObj){
                    this.$emit('getValue', this.dataListSelections1, this.name);
                } else {
                    this.$emit('getValue', value, this.name);
                }
            } else {
                console.log('okokokokokokok');
                if(this.btn){
                    this.$emit('getValue', this.dataListSelections, this.name);
                }else{
                    if(this.resultObj){
                        this.$emit('getValue', this.dataListSelections1, this.name);
                    } else {
                        this.$emit('getValue', value, this.name);
                    }
                }
            }
        },
        showSelectDialog() {
            this.visible = true;
            this.init();
        },
        changeVal(e) {
            if (this.ParentComponentName == 'goodsBuyChildForm') {
                this.$emit('getName', e.target.value);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

::v-deep .el-form-item {
    margin-bottom: 0;
}

.i1 {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
